<div class="icon__wrapper" [ngClass]="bgCssClass()">
  <i class="icon__icon" [ngClass]="[iconName(), iconCssClass()]"></i>
</div>
